import styled, { keyframes } from 'styled-components';

export const ReportPanelWrapper = styled.div<{ $isFullscreen?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  border-left: 1px solid #e8e8e8;

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    border-left: none;
  `}
`;

export const ReportHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
  gap: 12px;
`;

export const ReportHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const ReportHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ReportContent = styled.div`
  flex: 1;
  overflow: hidden;
  position: relative;
`;

export const ReportIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
  text-align: center;
  color: #8c8c8c;
`;

export const EmptyStateIcon = styled.div`
  font-size: 64px;
  margin-bottom: 16px;
  color: #d9d9d9;
`;

export const EmptyStateTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #595959;
`;

export const EmptyStateDescription = styled.div`
  font-size: 14px;
  margin-bottom: 24px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
  gap: 16px;
`;

export const LoadingMessage = styled.div`
  font-size: 14px;
  color: #595959;
  text-align: center;
  max-width: 400px;
  line-height: 1.5;
`;

export const SkeletonWrapper = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 800px;
`;

const pillPulse = keyframes`
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.65; }
`;

export const StreamingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(
    to bottom,
    rgb(255 255 255 / 20%) 0%,
    rgb(255 255 255 / 8%) 45%,
    rgb(255 255 255 / 2%) 100%
  );
  backdrop-filter: blur(0.6px);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  pointer-events: none;
`;

export const StreamingOverlayMessage = styled.div`
  margin: 12px 16px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgb(255 255 255 / 82%);
  color: #595959;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 1px 6px rgb(0 0 0 / 8%);
  animation: ${pillPulse} 2.4s ease-in-out infinite;
`;
